import { config } from '../../config/global'
import { makeRequest } from '../../utils/requests'
import { landingPageTemplate } from '../landing-page/landing-page'

export const createLandingPage = (
  countryId: string,
  name: string,
  path: string,
) =>
  makeRequest('post', '/landing_pages', {
    baseUrl: config.dodoBaseApiURL,
    data: {
      name,
      base_url: path,
      country_id: countryId,
      default_content: landingPageTemplate,
      theme_id: 'foodora',
    },
  })
